import './LoginRegister.css'
import {useEffect, useRef, useState} from "react";
import loginBGTop from '../../../assets/login-register/loginBGTop.png'
import loginBGBottom from '../../../assets/login-register/loginBGBottom.png'
import orSeparator from '../../../assets/login-register/orSeperatorIcon.svg'
import googleIcon from '../../../assets/login-register/googleIcon.svg'
import linkedinIcon from '../../../assets/login-register/linkedinIcon.svg'
import axios from "axios";
import {
    CustomErrorToast,
    CustomLoadingToast, CustomSuccessToast,
    CustomToastContainer, DismissToast,
    updateCustomErrorToast,
    updateCustomSuccessToast
} from "../../../components/utilities/CustomToast";
import checkEmail from "./Utilities";
import {Link, useNavigate, useParams} from "react-router-dom";
import FlexBox from "../../../components/utilities/FlexBox";
import { getUrlParameter} from "../../../utilities/Utilities";

import conff from '../../../assets/login-register/confirmation.png'
import {API_URL_PREFIX, APP_URL_PREFIX} from "../../../utilities/Constants";
import ModalBackground from "../../../components/utilities/modal/ModalBackground";
import InputText from "../../../components/utilities/InputText";
import Divider from "../../../components/utilities/Divider";
import {Button} from "react-bootstrap";
import LogoImg from '../../../assets/newLogo.svg'
import TextBoxWithIcon from "../../../components/utilities/TextBoxWithIcon";
import SocialLoginButton  from "../../../components/utilities/SocialLoginButton";

import {Building, Envelope, Google, Linkedin, Person, ShieldLock} from "react-bootstrap-icons";
import TermsAgreement from "./TermsAgreement";

const LoginRegister = () => {
    const params = useParams();
    let flow = "";
    if(params.flow){
        flow = params.flow;
    }
    useEffect(() => {
        document.title = "Login / Register"
    }, [])
    const [reset, setReset] = useState(flow == 'reset')
    const [login, setLogin] = useState(flow == 'login')
    const [confirmation, setConfirmation] = useState(false)

    useEffect(()=>{
        setReset(flow == 'reset')
        setLogin(flow == 'login')
    },[flow])
    return (
        <FlexBox className={"loginWrapper"} justify={"center"} align={"center"} style={{width: "100vw", height: "100vh"}}>
            <FlexBox justify={"space-between"} align={"center"} style={{width:"70%", minWidth:"min(1000px, 100%)", minHeight:"500px", height:(login ? "650px": "880px")}} className={"LoginContent"}>

                <FlexBox justify={"center"} align={"start"} direction={"column"} className={"p20 purple-section"} style={{overflow:"hidden" ,position:"relative" ,borderRadius:"40px 0px 0px 40px" ,paddingLeft:"120px",background:"#774CF3", width:"55%", height:"100%", color:"white"}}>
                    <h2 style={{color:"white", fontWeight:"bold", fontSize:"50px"}}>Welcome {login ? "Back" : ""} <br/>to Lugo-Test</h2>
                    <p style={{marginTop:"10px", fontSize:"20px"}}>Technical Hiring Platform</p>
                    <div style={{marginTop:"10px", borderTop:"1px solid #fff", width:"80px"}}></div>

                    <img src={loginBGTop} style={{position:"absolute", top:"-75px", left:"25px", width:"auto", height:"150px"}}/>
                    <img src={loginBGBottom} style={{position:"absolute", bottom:"-95px", right:"10px", width:"auto", height:"250px"}}/>

                </FlexBox>
                <FlexBox className={"p20 white-section"} style={{background:"#fff", width:"45%", height:"100%", borderRadius:"0px 40px 40px 0px"}}>
                    <div className="toast-container-wrapper">
                        <CustomToastContainer/>
                    </div>
                    {confirmation ? <Confirmation /> : <Content reset={reset} setReset={setReset} setLogin={setLogin} login={login} setConfirmation={setConfirmation}/>}
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )
}

function Login({setLogin}) {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")    
    const [sentActive, setSentActive] = useState(false)
    const [forgotPassword, setForgotPassword] = useState(false)
    const navigate = useNavigate()
    const [err, setErr] = useState(false)

    useEffect(()=>{
        if(getUrlParameter("active") == 1 && !sentActive){
            CustomSuccessToast("Your Company has been activated successfully!")
            setSentActive(true);
        }
        else if(getUrlParameter("errInfo") && !sentActive){
            CustomErrorToast(getUrlParameter("errInfo"));
            setSentActive(true);
        }
    },[])

    const login = () => {
        setErr(false)
        const id = CustomLoadingToast("Processing")
        let url = API_URL_PREFIX+ "/LoginLiteCompany.html";
        let bodyFormData = new FormData();
        bodyFormData.append('email', email.toLowerCase());
        bodyFormData.append('password', password);

        let data = {email: email, password: password}
        if(getUrlParameter("tk")){
            data["tk"] = getUrlParameter("tk")
        }

        axios.post(url, data)
            .then((res) => res.data)
            .then(res => {
                console.log(res)
                if (res.result === true) {
                    updateCustomSuccessToast("Success!", id)
                    if(getUrlParameter("redirect")){
                        try{
                            // redirect to decoded url
                            window.location.href = atob(getUrlParameter("redirect"));
                        }
                        catch(e){
                    navigate(APP_URL_PREFIX + "/dashboard");
                        }
                    }
                    else{
                        navigate(APP_URL_PREFIX + "/dashboard");
                    }
                } else {
                    setErr(true)
                    updateCustomErrorToast(res.info, id)
                }
            })
            .catch(error => {
                updateCustomErrorToast("You have entered an invalid email or password", id)
            })
    }

    return <div className={"fadeInElement"} onKeyDownCapture={e => {
        if (e.key === 'Enter') {
            login()
        }
    }}>
        <FlexBox style={{fontWeight: '300', width: "100%", marginTop: "25px"}} direction={"column"} justify={"left"}
                 align={"start"}>
            <div className="login-title" style={{marginBottom: "5px", fontSize: "20px", color: "#000000", fontWeight:600, fontFamily: "Nunito ", position:"relative", top: "-15px",paddingTop:"10px"}}>
                Log In to your Account
            </div>

            <TextBoxWithIcon
                label="Email"
                placeholder={"Email"}
                Img={Envelope}
                imgColor={"#C0C0C0"}
                altText={"email"}
                inputType={"text"}
                value={email}
                onChange={e => setEmail(e.target.value)}
                className={"form-control"}
                wrapperClassName={"input"}
                wrapperStyle={{ width: 360, height: 46 }}
                inputStyle={{ fontSize: '16px' }}
            />

            <br/>
            <TextBoxWithIcon
                label="Password"
                placeholder={"Password"}
                Img={ShieldLock}
                imgColor={"#C0C0C0"}
                altText={"password"}
                inputType={"password"}
                value={password}
                onChange={e => setPassword(e.target.value)}
                className={"form-control"}
                wrapperClassName={"input"}
                wrapperStyle={{ width: 360, height: 46, border: '0.71px solid #7a7a7a' }}
                inputStyle={{ fontSize: '16px' }}
            />

        </FlexBox>
        <span hidden={!err} id={"errIndicator"}> </span>

        <FlexBox className="forgot-password-container" style={{fontWeight: '300', color: "#C0C0C0", fontSize: "13px", marginTop: "10px"}} justify={"end"}>

            <span>
                <Link style={{color: "#774CF3", textDecoration: "none", fontWeight: "bold", fontSize: "14px"}} to={"#"}
                      onClick={e => setForgotPassword(true)}>Forgot Password</Link>
            </span>
        </FlexBox>
        <br/>

        <button disabled={!checkEmail(email) || password.length < 6} onClick={login} style={{width: 360, height: 40, backgroundColor: !checkEmail(email) || password.length < 6 ? '#AA9EFF' : '#7249E8', fontSize: 16, fontFamily: 'Nunito' }} className={"loginButton"}>Login
        </button>
        <br/>
        <div className="or-separator" style={{ display: 'flex', alignItems: 'center', width: '400px', marginTop: '30px', marginLeft: '-20px'}}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#e0e0e9' }}></div>
            <span style={{ padding: '0 10px', fontSize: '12px', color: '#000' }}>or</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#e0e0e9' }}></div>
        </div>

        <div className="social-buttons-container" style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '30px', marginTop: '50px' }}>
            <SocialLoginButton
                icon={googleIcon}
                label="Login Using Google"
                href="/oauth2/authorize/google.html"
            />
            <SocialLoginButton
                disabled={!checkEmail(email) || password.length < 6}
                icon={linkedinIcon}
                label="Login Using LinkedIn"
                href="/oauth2/authorize/linkedin.html"
            />
        </div>


        <div style={{color: "#676666", width: "100%", textAlign: "center", fontSize: "14px"}}>Don't have an account
            yet? <Link style={{color: "#7144F1", textDecoration: "none", fontSize: "15px", fontWeight:"600"}} to={"#"} onClick={e => setLogin(false)}>Sign Up</Link>.
        </div>
        {/*<button onClick={() =>*/}
        {/*    window.location.href = "/oauth2/authorize/linkedin.html"*/}
        {/*} className={"loginButton"} style={{background: "#0A66C2", marginTop: "10px"}}>*/}
        {/*    <FlexBox style={{gap: "10px"}}>*/}
        {/*        <Linkedin/>*/}
        {/*        <span>Login Using LinkedIn</span>*/}
        {/*    </FlexBox>*/}
        {/*</button>*/}

        {/*<br/>*/}
        {/*<button onClick={() =>*/}
        {/*    window.location.href = "/oauth2/authorize/google.html"*/}
        {/*} className={"loginButton"} style={{background: "rgb(217, 81, 64)", marginTop: "10px"}}>*/}
        {/*    <FlexBox style={{gap: "10px"}}>*/}
        {/*        <Google/>*/}
        {/*        <span>Login Using Google</span>*/}
        {/*    </FlexBox>*/}
        {/*</button>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<br/>*/}
        {/*<div style={{color: "#C0C0C0", width: "100%", textAlign: "center", fontSize: "13px"}}>Don't have an account*/}
        {/*    yet? <Link style={{color: "#774CF3", textDecoration: "none", fontWeight: "bold", fontSize: "13px"}} to={"#"}*/}
        {/*               onClick={e => setLogin(false)}>Sign Up</Link>.*/}
        {/*</div>*/}
        <br/>

        {forgotPassword && <ForgotPassword setShow={setForgotPassword}/>}
    </div>
}

const Confirmation = () => {
    return (
        <div style={{
            flexGrow: 2,
            display: "flex",
            height: "100%",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center"
        }} className={"confirmation"}>
            <img src={conff}/>
            <h4>
            Congratulations! Your company has been created successfully.<br/>
                Please check your registered email for verification and next steps.
        </h4>
        </div>
    )
}

const Content = ({login, setLogin, setConfirmation,setReset,reset}) => {
    return (<div className="content-wrapper" style={{
        flexGrow: 2,
        display: "flex",
        width: "40%",
        height: "100%",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    }}>
        <div className="login-content-inner" style={{display: "flex", width: "360px", justifyContent: "center", flexDirection: "column", alignItems:"center"}}>
            <a href={"https://lugo-test.com/"} style={{
                display: "flex",
                fontSize: "20px",
                alignItems: "center",
                textDecoration:"none",
                marginBottom:"15px",
                gap:"10px",
            }} className={"page no-hover-background"}>
                <img src={LogoImg} alt={"home"} />
                <div style={{fontWeight:"bold", fontSize:"30px"}}>Lugo-Test</div>
            </a>

            <div style={{width:"100%"}}>
                {reset ? <Reset reset={reset} setReset={setReset} /> : <>
                    {login ?
                        <Login setLogin={setLogin}/> :
                        <Register setConfirmation={setConfirmation} setLogin={setLogin}/> }
                </>}
            </div>
        </div>
    </div>)
}

const Reset = ({setReset,reset}) => {

    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [done, setDone] = useState(false)


    const resetPassword = () => {
        const id = CustomLoadingToast("Processing")

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

        if(!passwordRegex.test(password)){
            updateCustomErrorToast("Password is too weak.",id)
            return;
        }

        if (!password || password.length < 6) {
            updateCustomErrorToast("Password must contain 8-30 characters.",id)
            return;
        }
        if (password != confirmPassword) {
            updateCustomErrorToast("Passwords do not match.",id)
            return;
        }

        axios.post(API_URL_PREFIX+"/ResetPassword.html", {password, token:getUrlParameter("t")})
            .then(res => {
                let data = res.data
                if (data && data.result == true) {
                    DismissToast(id)
                    setDone(true)
                } else {
                    if (data && data.info) {
                        updateCustomErrorToast(data.info, id)
                    }
                    else {
                        updateCustomErrorToast("Error, Please try again.", id)
                    }
                }
            })
            .catch(error => {
                updateCustomErrorToast("Error, Please try again.", id)
            })
    }
    if(done){
        return (
            <FlexBox style={{fontWeight: '300'}} direction={"column"} justify={"left"} align={"start"}>
                <p style={{fontSize:"18px", textAlign:"center", border:"1px solid #000", padding:"25px 15px", background:"#774CF3", color:"white"}}>Your password has been changed.<br/>Click <a style={{color:"white"}} href={"/users/login"}>here</a> to login.</p>

            </FlexBox>
        )
    }

    return (<div onKeyDownCapture={e => {
        if (e.key === 'Enter') {
            resetPassword()
        }
    }}>

        <FlexBox style={{fontWeight: '300'}} direction={"column"} justify={"left"} align={"start"}>
            <h3 style={{textDecoration:"none", textAlign:"center", width:"100%", fontWeight:200}}>Reset your password</h3>
            <br/>

            <TextBoxWithIcon
                placeholder={"New Password"}
                Img={ShieldLock}
                imgColor={"#C0C0C0"}
                altText={"password"}
                inputType={"password"}
                value={password}
                onChange={e => {
                    setPassword(e.target.value);
                }}
                wrapperClassName={"form-control" + " input afterWrapper "}
                className={"input"}
                required={true}
                maxLength={30}
            />
            <br/>

            <TextBoxWithIcon
                placeholder={"Confirm New Password"}
                Img={ShieldLock}
                imgColor={"#C0C0C0"}
                altText={"password"}
                inputType={"password"}
                value={confirmPassword}
                onChange={e => {
                    setConfirmPassword(e.target.value);
                }}
                wrapperClassName={"form-control" + " input afterWrapper " }
                className={"input"}
                required={true}
                maxLength={30}
            />

            <span style={{textAlign:"left",marginBottom: "15px", fontSize: "13px", color: "#C0C0C0"}}>Your password must be at least 8 characters long, include both upper and lower case letters, and contain at least one special character.</span>
        </FlexBox>
        <br/>
        <button onClick={resetPassword} className={"loginButton"}>Save Changes</button>
    </div>)
}



const Register = ({setLogin, setConfirmation}) => {
    const [isChecked, setIsChecked] = useState(false)
    const [name, setName] = useState("")
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [email, setEmail] = useState("")
    const [status, setStatus] = useState({})
    const [isCompany, setIsCompany] = useState(true)

    const register = () => {
        let stat = {}

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

        if (!password || password.length < 8) {
            stat = ({...stat, p: true})
        }

        if(!passwordRegex.test(password)){
            stat = ({...stat, pe: true})
        }


        if (password != confirmPassword) {
            CustomErrorToast("Passwords do not match")
            stat = ({...stat, cp: true})
        }
        if(isCompany){
            if (!name || name.length < 2) {
                stat = ({...stat, u: "short"})
            }
        }
        if (!email || email.length < 2) {
            stat = ({...stat, e: "short"})
        }
        if (!firstName || firstName.length < 2) {
            stat = ({...stat, fu: "short"})
        }
        if (!lastName || lastName.length < 1) {
            stat = ({...stat, lu: "short"})
        }
        setStatus(stat)
        if (Object.values(stat).find(e => (e === true || e === "short" || e == "taken"))) return;
        const tk = getUrlParameter("tk")
        const referrer = getUrlParameter("ref")
        const id = CustomLoadingToast("Processing")
        let payload = {name: name, password: password, email: email, isCompany:!!isCompany, firstName, lastName};
        if(referrer){
            payload.referrer = referrer;
        }
        if(tk){
            payload.tk = tk;
        }
        axios.post(API_URL_PREFIX+"/RegisterLiteCompany.html", payload)
            .then(res => {
                let data = res.data
                if (data.result == true) {
                    DismissToast(id)
                    setConfirmation(true)
                } else {
                    if (data.info == "email") {
                        setStatus(({...stat, e: "taken"}));
                        updateCustomErrorToast("Email address already exists.", id)
                    } else if (data.info == "invalid") {
                        setStatus(({...stat, e: true}));
                        updateCustomErrorToast("Email address is invalid.", id)
                    }
                    else if (data.info == "no-work-domain") {
                        setStatus(({...stat, e: "no-work-domain"}));
                        updateCustomErrorToast("Email is not associated with known workplace domains.", id)
                    }
                    else {
                        updateCustomErrorToast("Error creating user, Please try again.", id)
                    }
                }
            })
            .catch(error => {
                updateCustomErrorToast("Error creating user, Please try again.", id)
            })
    }


    return (<div className={`fadeInElement register-form ${isCompany ? 'business-mode' : 'personal-mode'}`} onKeyDownCapture={e => {
        if (e.key === 'Enter') {
            register()
        }
    }}>


        <FlexBox style={{fontWeight: '300'}} direction={"column"} justify={"left"} align={"start"}>
            <div className="business-switch-wrapper">
                <BusinessSwitch isCompany={isCompany} setIsCompany={setIsCompany} e={status?.e}/>
            </div>
            <br/>
            <div className="company-name-wrapper" hidden={!isCompany} style={{width: "100%"}}>


                <TextBoxWithIcon
                    label={"Company Name"}
                    placeholder={"Company Name"}
                    Img={Building}
                    imgColor={"#C0C0C0"}
                    altText={"company"}
                    inputType={"text"}
                    value={name}
                    onChange={e => {
                        setName(e.target.value);
                        if (e.target.value.length > 1) {
                            setStatus({...status, u: null})
                        }
                    }}
                    wrapperClassName={"form-control" + " input afterWrapper " + " " + (status.u ? " error " : "") + (status.u == 'short' ? " usernameErr " : " ")}
                    className={"input"}
                    required={true}
                    maxLength={30}
                />
                <br/>
            </div>

            <FlexBox className="name-fields-row" style={{gap: "15px"}}>
                <div>
                    <TextBoxWithIcon
                        label={"First Name"}
                        placeholder={"First Name"}
                        Img={Person}
                        imgColor={"#C0C0C0"}
                        altText={"first Name"}
                        inputType={"text"}
                        value={firstName}
                        onChange={e => {
                            setFirstName(e.target.value);
                            if (e.target.value.length > 1) {
                                setStatus({...status, u: null})
                            }
                        }}
                        wrapperClassName={"form-control" + " input afterWrapper " + " " + (status.u ? " error " : "") + (status.fu == 'short' ? " firstNameErr " : " ")}
                        className={"input"}
                        required={true}
                        maxLength={30}
                    /><br/>
                </div>

                <div>

                    <TextBoxWithIcon
                        label={"Last Name"}
                        placeholder={"Last Name"}
                        Img={Person}
                        imgColor={"#C0C0C0"}
                        altText={"first Name"}
                        inputType={"text"}
                        value={lastName}
                        onChange={e => {
                            setLastName(e.target.value);
                            if (e.target.value.length > 1) {
                                setStatus({...status, u: null})
                            }
                        }}
                        wrapperClassName={"form-control" + " input afterWrapper " + " " + (status.u ? " error " : "") + (status.lu == 'short' ? " lastNameErr " : " ")}
                        className={"input"}
                        required={true}
                        maxLength={30}
                    /><br/>
                </div>

            </FlexBox>


            <TextBoxWithIcon
                label={"Email"}
                placeholder={(isCompany ? "Business " : "") + "Email"}
                Img={Envelope}
                imgColor={"#C0C0C0"}
                altText={"email"}
                inputType={"email"}
                value={email}
                onChange={e => setEmail(e.target.value)}
                wrapperClassName={"form-control" + " input afterWrapper " + " " + (status.e ? " error " : "") + (status.e == 'short' ? "shortEmailErr" : "") + (status.e == 'taken' ? "emailErr" : "") + ((status.e == "no-work-domain" && isCompany) ? "emailWPErr" : "") + " " + (status.e === true ? "emailInvalid" : "") + " " + ((status.e == 'valid' && email) ? "emailValid" : "")}
                className={"input"}
                required={true}
                maxLength={128}
            />

            <small hidden={!isCompany} style={{textAlign: "left", width: "100%", color: "#C0C0C0", fontSize: "13px"}}>*
                Must be business/workplace email domain.</small>
            <br/>
            <TextBoxWithIcon
                label={"Password"}
                placeholder="Password"
                Img={ShieldLock}
                imgColor={"#C0C0C0"}
                altText={"password"}
                inputType={"password"}
                value={password}
                onChange={e => {
                    setPassword(e.target.value);
                    if (e.target.value.length > 1) {
                        setStatus({...status, p: null})
                    }
                }}
                wrapperClassName={"form-control" + " input afterWrapper " + " " + (status.p ? " error " : "") + (status.p ? "passwordErr" : "") + (status.pe ? " passwordErrRegex" : "")}
                className={"input"}
                required={true}
                maxLength={30}
            /><br/>

            <TextBoxWithIcon
                label={"Confirm Password"}
                placeholder="Confirm Password"
                Img={ShieldLock}
                imgColor={"#C0C0C0"}
                altText={"confirm password"}
                inputType={"password"}
                value={confirmPassword}
                onChange={e => {
                    setConfirmPassword(e.target.value);
                }}
                wrapperClassName={"form-control" + " input  "}
                className={"input"}
                required={true}
                maxLength={30}
            />

            <span className="password-requirements-text" style={{textAlign: "left", marginBottom: "15px", fontSize: "13px", color: "#C0C0C0"}}>Your password must be at least 8 characters long, and include both upper and lower case letters</span>

            <TermsAgreement onChange={(checked) => setIsChecked(checked)}/>


            <div hidden={!isCompany} style={{
                textAlign: "center",
                margin: "15px 0px",
                fontWeight: "bold",
                fontSize: "16px",
                width: "100%",
                color: "#774CF3"
            }}>Free tests for business accounts!
            </div>
        </FlexBox>
        {/* Disable the Sign Up button if terms are not accepted */}
        <button onClick={register} className="loginButton" disabled={!isChecked} style={{width: 360, height: 40, backgroundColor: !isChecked ? '#AA9EFF' : '#7249E8', fontSize: 14, fontFamily: 'Nunito', fontWeight: 600 }}>
            Sign Up
        </button>

        <div className="or-separator" style={{ display: 'flex', alignItems: 'center', width: '400px', marginTop: '15px', marginLeft: '-20px'}}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#e0e0e9' }}></div>
            <span style={{ padding: '0 10px', fontSize: '12px', color: '#000' }}>or</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#e0e0e9' }}></div>
        </div>
        {/*<button onClick={() =>*/}
        {/*    window.location.href = "/oauth2/authorize/linkedin.html"*/}
        {/*} className={"loginButton"} style={{background: "#0A66C2", marginTop: "10px"}}>*/}
        {/*    <FlexBox style={{gap: "10px"}}>*/}
        {/*        <Linkedin/>*/}
        {/*        <span>Login Using LinkedIn</span>*/}
        {/*    </FlexBox>*/}
        {/*</button>*/}
        {/*<button onClick={() =>*/}
        {/*    window.location.href = "/oauth2/authorize/google.html"*/}
        {/*} className={"loginButton"} style={{background: "rgb(217, 81, 64)", marginTop: "10px"}}>*/}
        {/*    <FlexBox style={{gap: "10px"}}>*/}
        {/*        <Google/>*/}
        {/*        <span>Sign Up Using Google</span>*/}
        {/*    </FlexBox>*/}
        {/*</button>*/}
        <div className="social-buttons-container" style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px', marginTop: '25px' }}>
            <SocialLoginButton
                icon={googleIcon}
                label="Sign Up Using Google"
                href="/oauth2/authorize/google.html"
            />
            <SocialLoginButton
                disabled={!checkEmail(email) || password.length < 6}
                icon={linkedinIcon}
                label="Sign Up Using LinkedIn"
                href="/oauth2/authorize/linkedin.html"
            />
        </div>
        <div className="already-account-text" style={{color: "#676666", width: "100%", textAlign: "center", fontSize: "14px"}}>Already have an
            account? <Link style={{color: "#7144F1", textDecoration: "none", fontSize: "15px", fontWeight:"600"}}
                           to={"#"} onClick={e => setLogin(true)}>Login</Link>.
        </div>
        <br/>

    </div>)
}

const RadioDiv = ({selected, onClick, label}) => {
    return <FlexBox justify={"center"} style={{
        gap: "15px",
        border: "1px solid " + (selected ? "#774CF3" : "#C0C0C0"),
        width: "40%",
        borderRadius: "5px",
        fontSize: "14px",
        height: "30px"
    }}>
        <input checked={selected} onClick={onClick} type={"radio"}/>
        {label}
    </FlexBox>
}

const BusinessSwitch = ({isCompany, setIsCompany, e}) =>{
    return <>

        <FlexBox className="radio-buttons-row" justify={"space-between"} style={{width:"100%"}}>
            <RadioDiv onClick={()=>setIsCompany(true)} selected={isCompany} label={"Business"} />
            <RadioDiv onClick={()=>setIsCompany(false)} selected={!isCompany} label={"Personal"} />
        </FlexBox>
        <div style={{textAlign:"center", marginBottom:"10px"}} hidden={e!="no-work-domain"}>For private businesses, contact us at <a href={"mailto:info@lugo-test.com"}>info@lugo-test.com</a> for 2 free demo tests.</div>
    </>
}


const ForgotPassword = ({setShow}) =>{
    const [email, setEmail] = useState("")
    const [submitted, setSubmitted] = useState(false)
    const ref = useRef()


    const mouseOutHandle = e=>{
        setShow(show =>{
            if(show){
                if(ref.current && !ref.current.contains(e.target)){
                    return false;
                }
            }
            return show;
        })
    }

    useEffect(()=>{
        document.addEventListener('mousedown',mouseOutHandle)
        return (()=>{
            document.removeEventListener('mousedown',mouseOutHandle)
        })
    },[])

    const resetPassword = ()=>{
        if(!email || !checkEmail(email)) {
            CustomErrorToast("Invalid Email")
            return;
        }
        const id = CustomLoadingToast("Processing...")
        axios.post(API_URL_PREFIX+"/ResetPasswordRequest.html",{email})
            .then(e=>{
                let data = e.data;
                if(data && !data.err){
                    setSubmitted(true)
                    DismissToast(id)
                }
                else{
                    if(data.info){
                        updateCustomErrorToast(data.info,id)
                    }
                    else{
                        updateCustomErrorToast("Error, please try again.",id)
                    }
                }
            })
            .catch(err=>{
                updateCustomErrorToast("Error, please try again.",id)
                console.log(err)
            })
    }

    return (
        <ModalBackground>

            <FlexBox refVar={ref} direction={"column"} justify={"start"} className={"hard-shadow"}
                     style={{borderRadius:"7px",fontWeight:"400",width:"80%", maxWidth:"300px", background:"white", padding:"15px"}}>
                {submitted ? <p style={{width:"100%", textAlign:"center"}}>Reset instructions has been sent to {email}</p> :
                    <>
                    <h3>Reset Password</h3>
                    <Divider />

                    <InputText marginRight={"0"} width={"100%"} field={email} setField={e=>setEmail(e.target.value)} label={"Email"} required={true} />
                    <br/>
                    <Button onClick={resetPassword} variant={"success"}>Reset Password</Button>
</>
                }
            </FlexBox>

        </ModalBackground>
    )
}


export default LoginRegister

